import request from '@/utils/request'

// 我的信息
export function getUserInfo(params) {
  return request({
    url: "/sixpack/front/student/queryStudentWxInfo",
    method: "GET",
    data: params
  });
}

// 退出登录
export function logout() {
  return request({
    url: '/coyote/front/backstage/logout',
    method: 'post',
  })
}